import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "button"];
  static values = { revealed: { type: Boolean, default: false } };

  connect() {
    this.updateDisplay();
  }

  toggle() {
    this.revealedValue = !this.revealedValue;
    this.updateDisplay();
  }

  updateDisplay() {
    if (this.revealedValue) {
      this.contentTarget.classList.remove("blur-sm", "select-none");
      this.buttonTarget.textContent = "Hide Spoiler";
      this.buttonTarget.classList.remove(
        "bg-orange-500",
        "hover:bg-orange-400"
      );
      this.buttonTarget.classList.add("bg-gray-500", "hover:bg-slate-500");
    } else {
      this.contentTarget.classList.add("blur-sm", "select-none");
      this.buttonTarget.textContent = "Show Spoiler";
      this.buttonTarget.classList.remove("bg-gray-500", "hover:bg-slate-500");
      this.buttonTarget.classList.add("bg-orange-500", "hover:bg-orange-400");
    }
  }
}
